import kfetch from '@kareo/kfetch';

import { isEmpty } from 'lodash';

const MaxConflictResults = 20;
const MsInDay = 24 * 60 * 60 * 1000;

export const AvailabilityStatus = {
  LOADING: 0,
  AVAILABLE: 1,
  CONFLICT: 2,
  UNAVAILABLE: 3, // ie. out of office hours, holiday, etc.
  ERROR: 4,
  UNKNOWN: 5,
  DELETED: 6,
};

class Availability {
  constructor() {
    this.instance = null;
  }

  createAvailabilityPayload(
    appointmentStartTime,
    appointmentDuration,
    recurrenceRules,
    maxAppointmentConflictResults = MaxConflictResults,
  ) {
    let payload = {
      duration: appointmentDuration,
      minCalendarDate: appointmentStartTime,
      maxAppointmentConflictResults,
      startTimeOfDay: appointmentStartTime % MsInDay,
    };

    if (!!recurrenceRules && !isEmpty(recurrenceRules)) {
      if (!!recurrenceRules.appointmentId) {
        payload.ignoredAppointmentId = recurrenceRules.appointmentId;
      }

      if (!!recurrenceRules.endDate && !recurrenceRules.numberOfTimes) {
        payload.maxCalendarDate = recurrenceRules.endDate;
      }

      if (!!recurrenceRules.dayInterval) {
        payload.ruleDayInterval = recurrenceRules.dayInterval;
      }

      if (!!recurrenceRules.monthInterval) {
        payload.ruleMonthInterval = recurrenceRules.monthInterval;
      }

      if (!!recurrenceRules.monthOfYear) {
        payload.ruleMonthOfYear = recurrenceRules.monthOfYear;
      }

      if (!!recurrenceRules.dayOfMonth) {
        payload.ruleDayOfMonth = recurrenceRules.dayOfMonth;
      }

      if (!!recurrenceRules.typeOfDay) {
        payload.ruleTypeOfDay = recurrenceRules.typeOfDay;
      }

      if (!!recurrenceRules.dayOfWeekFlags) {
        payload.ruleDayOfWeekFlags = recurrenceRules.dayOfWeekFlags;
      }

      if (!!recurrenceRules.numberOfTimes) {
        payload.ruleNumberOfTimes = recurrenceRules.numberOfTimes;
      }

      if (!!recurrenceRules.endDate && !recurrenceRules.numberOfTimes) {
        payload.maxCalendarDate = recurrenceRules.endDate;
      }
    } else {
      payload.maxCalendarDate = appointmentStartTime + appointmentDuration;
    }

    // TODO: Determine if we need more than this?
    // appt-conflict.coffee has a lot of logic regarding constructing the payload,
    // especially around recurrence but it doesn't look like those values get passed to the
    // service call, ie. a recurring appointment calls:
    // /dashboard-calendar-ui/api/Appointment/conflicts/?providerId=76594&duration=1800000&minCalendarDate=1547567100000&maxAppointmentConflictResults=20&startTimeOfDay=56700000&ruleDayOfWeekFlags=10
    return payload;
  }

  async checkAvailability(payload, abortSignal, appointmentIdToOmit) {
    if (!payload.providerId && !payload.resourceId) {
      throw new Error('checkAvailability requires a provider or resource Id');
    }

    let response;

    let payloadQs = Object.keys(payload)
      .map(key => `${key}=${payload[key]}`)
      .join('&');

    let url = `/dashboard-calendar-ui/api/Appointment/conflicts/?${payloadQs}`;

    try {
      response = await kfetch(url, abortSignal);
    } catch (error) {
      return AvailabilityStatus.ERROR;
    }

    if (!!appointmentIdToOmit) {
      let filteredAppointments = response.appointments.filter(
        appointment => appointment.appointmentId != appointmentIdToOmit,
      );
      response.appointments = filteredAppointments;
    }

    if (response.appointments.length > 0) {
      return AvailabilityStatus.CONFLICT;
    }

    if (
      response.outsideOfficeHours ||
      response.onBreak ||
      response.onHoliday ||
      response.onTimeOff
    ) {
      return AvailabilityStatus.UNAVAILABLE;
    }

    return AvailabilityStatus.AVAILABLE;
  }

  static get() {
    if (!this.instance) {
      this.instance = new Availability();
    }

    return this.instance;
  }
}

// Export a single instance of the Staff class
const availability = Availability.get();
export default availability;
